import { TOptionOf } from 'root-types'

export const FAMILY_SIZE_TYPE = {
  ONE_CHILD: 'one_child',
  TWO_CHILDREN: 'two_children',
  THREE_PLUS_CHILDREN: 'three_plus_children',
  NO_CHILDREN: 'no_children',
} as const

export const FAMILY_SIZE_OPTIONS = [
  {
    value: FAMILY_SIZE_TYPE.ONE_CHILD,
    text: 'onboarding.selectFamilySize.oneChild',
  },
  {
    value: FAMILY_SIZE_TYPE.TWO_CHILDREN,
    text: 'onboarding.selectFamilySize.twoChildren',
  },
  {
    value: FAMILY_SIZE_TYPE.THREE_PLUS_CHILDREN,
    text: 'onboarding.selectFamilySize.threePlusChildren',
  },
  {
    value: FAMILY_SIZE_TYPE.NO_CHILDREN,
    text: 'onboarding.selectFamilySize.noChildren',
  },
] as const satisfies readonly TOptionOf<typeof FAMILY_SIZE_TYPE>[]
